import React, {Component} from 'react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import forumlaTypeAPI from '../../apis/forumlaType'
import {withTranslation} from 'react-i18next'

class FormModal extends Component {
  formRef = React.createRef()

  handleOk = () => {
    const {handleCancel, handleSearch} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name
      }
      forumlaTypeAPI.addAction(params).then(res => {
        handleCancel('addModalVisible')
        handleSearch()
      })

    }).catch(err => { })
  }

  render() {
    const {addModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={`${t(`general.add`)} ${t(`formulaType.formulaType`)}`}
          closable={true}
          onCancel={() => {handleCancel('addModalVisible')}}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={() => {handleCancel('addModalVisible')}}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} span={24}>
                <Form.Item name="name" label={t(`formulaType.name`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`formulaType.name`)}`, pattern: new RegExp(/\S/)}]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
